import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: 'img'
})
export class LazyLoadingImagesDirective {
  constructor(el : ElementRef) {
    el.nativeElement.setAttribute('loading','lazy')
  }
}